import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import { kbdRecipe, type KbdRecipeProps } from '../recipes/kbd.recipe';

export interface KbdProps
  extends React.HTMLAttributes<HTMLElement>,
    KbdRecipeProps {}

/**
 * A keyboard shortcut hint.
 *
 *   <Kbd>⌘K</Kbd>
 *   <Kbd size="md">Esc</Kbd>
 *
 * Renders a real `<kbd>`, so assistive technology reads it as a key.
 */
export const Kbd = React.forwardRef<HTMLElement, KbdProps>(function Kbd(
  { size, className, ...props },
  ref
) {
  return (
    // design-tokens-ignore: owned by Kbd
    <kbd ref={ref} className={cn(kbdRecipe({ size }), className)} {...props} />
  );
});
